import {NDatePickerDirective} from "./nDatePicker.directive";
import {SelectOnFocusDirective} from "./selectOnFocus.directive";
import {OnlyDigitsDirective} from "./onlyDigits.directive";
import {NHintDirective} from "./nHint.directive";
import {AutoSizeDirective} from "./autoSize.directive";
import {NErrorsDirective} from "./nErrors.directive";
import {FocusOnDefaultDirective} from "./focusOnDefault.directive";
import {OnlySymbolsDirective} from "./onlySymbols.directive";

export const PUBLIC_DIRECTIVES = [
  NDatePickerDirective,
  SelectOnFocusDirective,
  OnlyDigitsDirective,
  OnlySymbolsDirective,
  NHintDirective,
  AutoSizeDirective,
  NErrorsDirective,
  FocusOnDefaultDirective,
];
